<script>
  export let viewBox;
</script>

<svg on:click class="icon" viewBox={viewBox}>
  <rect x="28.2" y="4.5" width="3.7" height="55.5"></rect>
  <polygon points="30,0 48.2,27.3 45.1,29.3 30,6.7 14.9,29.3 11.8,27.3 "
  ></polygon>
</svg>
